// extracted by mini-css-extract-plugin
export var address = "footer-module--address--e2a32";
export var addressContainer = "footer-module--addressContainer--8e174";
export var contactContainer = "footer-module--contactContainer--ca786";
export var contactTitle = "footer-module--contactTitle--78cce";
export var copyright = "footer-module--copyright--b80ae";
export var copyrightContainer = "footer-module--copyrightContainer--96e59";
export var footerContainer = "footer-module--footerContainer--5a73b";
export var link = "footer-module--link--9ad08";
export var linkBlocContainer = "footer-module--linkBlocContainer--9ba21";
export var linkBlocContent = "footer-module--linkBlocContent--cc994";
export var linkBlocTitle = "footer-module--linkBlocTitle--30d73";
export var linkContainer = "footer-module--linkContainer--8cbc8";
export var linkItem = "footer-module--linkItem--52ff3";
export var logoContainer = "footer-module--logoContainer--f4226";
export var logoImg = "footer-module--logoImg--1dbd8";
export var mainContainer = "footer-module--mainContainer--c38ce";
export var mediaContainer = "footer-module--mediaContainer--a9eb3";
export var miscellaneousContainer = "footer-module--miscellaneousContainer--0d437";
export var newsletterButtonContainer = "footer-module--newsletterButtonContainer--c81f4";
export var newsletterButtonTitle = "footer-module--newsletterButtonTitle--c4722";
export var newsletterContainer = "footer-module--newsletterContainer--2b78d";
export var newsletterTitle = "footer-module--newsletterTitle--82c1b";
export var phone = "footer-module--phone--d3482";
export var smartAddressContentContainer = "footer-module--smartAddressContentContainer--8f528";
export var smartAddressTitleContainer = "footer-module--smartAddressTitleContainer--408e2";
export var smartContactContainer = "footer-module--smartContactContainer--a861e";
export var smartContactTitle = "footer-module--smartContactTitle--e0186";
export var smartCopyright = "footer-module--smartCopyright--ef7c7";
export var smartCopyrightContainer = "footer-module--smartCopyrightContainer--d5a9a";
export var smartLink = "footer-module--smartLink--ec398";
export var smartLinkBlocContainer = "footer-module--smartLinkBlocContainer--d96a2";
export var smartLinkBlocContent = "footer-module--smartLinkBlocContent--8c1bc";
export var smartLinkBlocTitle = "footer-module--smartLinkBlocTitle--8d217";
export var smartLinkContainer = "footer-module--smartLinkContainer--6346b";
export var smartLinkItem = "footer-module--smartLinkItem--eb4b8";
export var smartLogoContainer = "footer-module--smartLogoContainer--29852";
export var smartLogoImg = "footer-module--smartLogoImg--54b44";
export var smartMainContainer = "footer-module--smartMainContainer--b1482";
export var smartMediaContainer = "footer-module--smartMediaContainer--97912";
export var smartMiscellaneousContainer = "footer-module--smartMiscellaneousContainer--8e6dc";
export var smartNewsletterButtonContainer = "footer-module--smartNewsletterButtonContainer--1fbed";
export var smartNewsletterButtonTitle = "footer-module--smartNewsletterButtonTitle--4af06";
export var smartNewsletterContainer = "footer-module--smartNewsletterContainer--861cf";
export var smartNewsletterTitle = "footer-module--smartNewsletterTitle--ce6ef";
export var smartSocialMediaContainer = "footer-module--smartSocialMediaContainer--6cd8e";
export var smartSocialMediaIconContainer = "footer-module--smartSocialMediaIconContainer--7425f";
export var smartSocialMediaItem = "footer-module--smartSocialMediaItem--f0924";
export var smartSocialMediaList = "footer-module--smartSocialMediaList--71f86";
export var smartSocialMediaTitle = "footer-module--smartSocialMediaTitle--b28c5";
export var socialMediaAnchor = "footer-module--socialMediaAnchor--1bf25";
export var socialMediaContainer = "footer-module--socialMediaContainer--bd3f4";
export var socialMediaIconContainer = "footer-module--socialMediaIconContainer--c7687";
export var socialMediaItem = "footer-module--socialMediaItem--f9089";
export var socialMediaList = "footer-module--socialMediaList--f643c";
export var socialMediaTitle = "footer-module--socialMediaTitle--4526a";